import React, {useState} from "react";
import {Grid} from "@mui/material";
import Button from "@mui/material/Button";
import {useWelcomeAssistantContext} from "./ContextType";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function FooterButtons(props: {
    forwardEnabled: boolean,
    backEnabled: boolean,
    forwardVisible: boolean,
    backVisible: boolean,
    labelForward: string,
    labelBack: string,
    onForward?: () => Promise<boolean>,
    increaseStepNumber: boolean,
    decreaseStepNumber: boolean,
}) {

    const {handlePrev, handleNext} = useWelcomeAssistantContext();
    const [promiseRunning, setPromiseRunning] = useState(false);

    return (
        <>
            {props.forwardVisible &&
                <Grid container justifyContent="left" paddingTop={3}>
                    <div>
                        <Button variant="contained" fullWidth={false} onClick={() => {
                            if (promiseRunning) {
                                return;
                            }
                            setPromiseRunning(true);

                            props.onForward().then((result) => {
                                setPromiseRunning(false);
                                if (result) {
                                    handleNext(props.increaseStepNumber);
                                }
                            });
                        }} style={{width: "100%"}} disabled={!props.forwardEnabled || promiseRunning}>
                            {props.labelForward}
                        </Button>
                    </div>
                </Grid>
            }

            {props.backVisible &&
                <Grid container justifyContent="left" style={{marginTop: '10px'}}>
                    <div>
                        <Button variant="outlined" fullWidth={false} startIcon={<ArrowBackIcon/>} onClick={() => {
                            handlePrev(props.decreaseStepNumber);
                        }} style={{width: "100%", border: 0}} disabled={!props.backEnabled}>
                            {props.labelBack}
                        </Button>
                    </div>
                </Grid>
            }
        </>
    );
}

FooterButtons.defaultProps = {
    forwardEnabled: true,
    backEnabled: true,
    forwardVisible: true,
    backVisible: true,
    labelForward: 'Los geht\`s!',
    labelBack: 'Zurück',
    increaseStepNumber: true,
    decreaseStepNumber: true,
    onForward: () => {
        return new Promise((resolve) => {
            resolve(true);
        });
    }
}
